import React from 'react';
import FeatureCard from '../components/FeatureCard';
import PageTitle from '../components/PageTitle';
import SEO from '../components/SEO';
import { useMetadata } from '../contexts/MetadataContext';
import '../styles/HomePage.css';

function HomePage() {
  const metadata = useMetadata();
  
  return (
    <div className="home-page">
      <PageTitle page="Home" />
      <SEO 
        title={`Home | ${metadata.title}`}
        description={metadata.description}
      />
      
      <section className="hero">
        <div className="hero-content">
          <h2>Welcome to {metadata.title.split('|')[0].trim()}</h2>
          <p>Connect, share, and explore with like-minded individuals</p>
        </div>
      </section>
      
      <section className="features">
        <h2 className="section-title">Featured Content</h2>
        
        <div className="feature-grid">
          <div className="placeholder-message">
            <h3>**social media contents placeholder**</h3>
            <p>Feature cards will be displayed here in the future.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
